"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.regexp.split");
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.sort");
var _toConsumableArray2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
require("core-js/modules/es6.number.constructor");
var _index = require("@/api/index");
var _vueCropper = require("vue-cropper");
var _imageViewer = _interopRequireDefault(require("element-ui/packages/image/src/image-viewer"));
var _vuedraggable = _interopRequireDefault(require("vuedraggable"));
var _default = {
  components: {
    VueCropper: _vueCropper.VueCropper,
    ElImageViewer: _imageViewer.default,
    vuedraggable: _vuedraggable.default
  },
  props: {
    dialogWidth: {
      type: String,
      default: "400px"
    },
    showType: {
      type: String,
      default: "button"
    },
    accept: {
      type: String
    },
    tip: {
      type: String,
      default: ""
    },
    subTip: {
      type: String,
      default: ""
    },
    fileSize: {
      type: String,
      default: "2M"
    },
    imgWidth: {
      type: Number
    },
    imgHeight: {
      type: Number
    },
    wrapperWidth: {
      type: String,
      default: "auto"
    },
    wrapperHeight: {
      type: String
    },
    alwaysCrop: {
      type: Boolean,
      default: false
    },
    fixedBox: {
      type: Boolean,
      default: true
    },
    autoCropWidth: {
      type: Number
    },
    autoCropHeight: {
      type: Number
    },
    fixScale: {
      type: Boolean,
      default: false
    },
    cropperWidth: {
      type: String,
      default: '100%'
    },
    cropperHeight: {
      type: String
    },
    photoWidth: {
      type: Number,
      default: 95
    },
    photoHeight: {
      type: Number,
      default: 95
    },
    initVal: {},
    enlarge: {
      type: Number,
      default: 1
    },
    minWidth: {
      type: Number
    },
    minHeight: {
      type: Number
    },
    multiple: {
      type: Boolean,
      default: false
    },
    maxNum: {
      type: Number,
      default: 10
    },
    sort: {
      type: Boolean,
      default: false
    },
    isSquare: {
      type: Boolean,
      default: false
    },
    hideDelete: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    outputType: function outputType() {
      if (this.accept && this.accept.indexOf('png') > -1 || this.alwaysCrop) {
        return 'png';
      } else {
        return 'jpeg';
      }
    },
    imgUrl: function imgUrl() {
      return this.multiple ? "" : this.initVal ? this.initVal : "";
    },
    fileList: function fileList() {
      return this.multiple ? this.initVal ? this.initVal : [] : [];
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      // 裁剪组件的基础配置option
      option: {
        img: '',
        // 裁剪图片的地址
        info: true,
        // 裁剪框的大小信息
        outputSize: 0.8,
        // 裁剪生成图片的质量
        canScale: true,
        // 图片是否允许滚轮缩放
        autoCrop: true,
        // 是否默认生成截图框
        full: false,
        // 是否输出原图比例的截图
        canMoveBox: true,
        // 截图框能否拖动
        original: true,
        // 上传图片按照原始比例渲染
        infoTrue: true,
        // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        canMove: true
      },
      loading: false,
      fileInfo: null,
      showViewer: false,
      sortList: [],
      showUrl: ''
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      if (_this.multiple) {
        _this.sortList = (0, _toConsumableArray2.default)(_this.fileList);
      }
    });
  },
  watch: {
    sortList: {
      handler: function handler(val) {
        if (this.sort) {
          this.$emit("setVal", val, 'sort');
        }
      },
      deep: true
    }
  },
  methods: {
    previewImg: function previewImg(url) {
      var _this2 = this;
      this.showUrl = url;
      this.$nextTick(function () {
        _this2.showViewer = true;
      });
    },
    // 删除
    delImg: function delImg(index) {
      if (this.multiple) {
        this.$emit("setVal", index, 'del');
      } else {
        this.$emit("setVal", "");
      }
    },
    // 关闭预览
    closeViewer: function closeViewer() {
      this.showViewer = false;
    },
    // 直接上传
    cancelCrop: function cancelCrop() {
      var _this3 = this;
      if (this.imgWidth || this.imgHeight || this.minWidth || this.minHeight || this.isSquare) {
        this.sizeCheck(this.fileInfo).then(function (res) {
          if (res) {
            var fd = new FormData();
            fd.append("file", _this3.fileInfo);
            (0, _index.upload)(fd).then(function (res) {
              if (_this3.multiple) {
                _this3.$emit("setVal", res.image, 'add');
              } else {
                _this3.$emit("setVal", res.image);
              }
              _this3.dialogVisible = false;
            });
          }
        });
      } else {
        var fd = new FormData();
        fd.append("file", this.fileInfo);
        (0, _index.upload)(fd).then(function (res) {
          if (_this3.multiple) {
            _this3.$emit("setVal", res.image, 'add');
          } else {
            _this3.$emit("setVal", res.image);
          }
          _this3.dialogVisible = false;
        });
      }
    },
    // 裁剪
    finish: function finish() {
      var _this4 = this;
      this.loading = true;
      this.$refs.cropper.getCropBlob(function (data) {
        var file = new window.File([data], _this4.fileInfo.name, {
          type: data.type
        });
        if (_this4.imgWidth || _this4.imgHeight || _this4.minWidth || _this4.minHeight || _this4.isSquare) {
          _this4.sizeCheck(file).then(function (res) {
            if (res) {
              var fd = new FormData();
              fd.append("file", file);
              (0, _index.upload)(fd).then(function (res) {
                _this4.loading = false;
                if (_this4.multiple) {
                  _this4.$emit("setVal", res.image, 'add');
                } else {
                  _this4.$emit("setVal", res.image);
                }
                _this4.dialogVisible = false;
              }).catch(function (error) {
                _this4.loading = false;
              });
            }
          }).catch(function () {
            _this4.loading = false;
          });
        } else {
          var fd = new FormData();
          fd.append("file", file);
          (0, _index.upload)(fd).then(function (res) {
            _this4.loading = false;
            if (_this4.multiple) {
              _this4.$emit("setVal", res.image, 'add');
            } else {
              _this4.$emit("setVal", res.image);
            }
            _this4.dialogVisible = false;
          }).catch(function (error) {
            _this4.loading = false;
          });
        }
      });
    },
    sizeCheck: function () {
      var _sizeCheck = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(file) {
        var that, flag, minWValid, minHValid, imgWValid, imgHValid, isSize;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = this;
                _context.next = 3;
                return new Promise(function (resolve, reject) {
                  var _URL = window.URL || window.webkitURL;
                  var img = new Image();
                  img.onload = function () {
                    minWValid = that.minWidth ? img.width >= that.minWidth : true;
                    minHValid = that.minHeight ? img.height >= that.minHeight : true;
                    imgWValid = that.imgWidth ? img.width == that.imgWidth : true;
                    imgHValid = that.imgHeight ? img.height == that.imgHeight : true;
                    flag = that.isSquare ? img.width === img.height : true;
                    minWValid && minHValid && imgWValid && imgHValid && flag ? resolve() : reject();
                  };
                  img.src = _URL.createObjectURL(file);
                }).then(function () {
                  return file;
                }, function () {
                  if (!flag) {
                    that.$message.error('图片要求为正方形！');
                  } else if (!minWValid) {
                    that.$message.error('图片尺寸要求宽度最小为' + that.minWidth + 'px！');
                  } else if (!minHValid) {
                    that.$message.error('图片尺寸要求高度最小为' + that.minHeight + 'px！');
                  } else if (!imgWValid) {
                    that.$message.error('图片尺寸要求宽度为' + that.imgWidth + 'px！');
                  } else if (!imgHValid) {
                    that.$message.error('图片尺寸要求高度为' + that.imgHeight + 'px！');
                  }
                  return Promise.reject();
                });
              case 3:
                isSize = _context.sent;
                return _context.abrupt("return", isSize);
              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function sizeCheck(_x) {
        return _sizeCheck.apply(this, arguments);
      }
      return sizeCheck;
    }(),
    // 上传前对文件的大小进行判断
    beforeUpload: function beforeUpload(file) {
      this.fileInfo = file;
      var isFileSize = true,
        hasAccept = true,
        isSize = true;
      if (this.fileSize) {
        var size = parseInt(this.fileSize.slice(0, -1));
        if (this.fileSize.indexOf('K') > -1) {
          isFileSize = file.size / 1024 < size;
        }
        if (this.fileSize.indexOf('M') > -1) {
          isFileSize = file.size / 1024 / 1024 < size;
        }
        if (!isFileSize) {
          this.$message({
            message: "上传文件大小不能超过" + this.fileSize,
            type: "error"
          });
          return false;
        }
      }
      if (this.accept) {
        var fileExt = file.name.substring(file.name.lastIndexOf('.'));
        var list = this.accept.split(',');
        hasAccept = list.find(function (item) {
          return item === fileExt;
        }) ? true : false;
        if (!hasAccept) {
          this.$message({
            message: "上传文件类型必须为" + this.accept,
            type: "error"
          });
          return false;
        }
      }
      if (this.alwaysCrop) {
        this.option.img = URL.createObjectURL(file);
        this.dialogVisible = true;
        return false;
      }
      if (this.imgWidth || this.imgHeight || this.minWidth || this.minHeight || this.isSquare) {
        isSize = this.sizeCheck(file);
      }
      return isFileSize && hasAccept && isSize;
    },
    // 覆盖默认上传行为
    httpRequest: function httpRequest(params) {
      var _this5 = this;
      var fd = new FormData();
      fd.append("file", params.file);
      (0, _index.upload)(fd).then(function (res) {
        if (_this5.multiple) {
          _this5.$emit("setVal", res.image, 'add');
        } else {
          _this5.$emit("setVal", res.image);
        }
      });
    }
  }
};
exports.default = _default;